import { iconTitle } from 'constants/fonts';
import { defaultPaddingLeft } from 'constants/sizes';
import Device from 'constants/deviceSizes';
import Images from 'config/assets';

export default {
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    padding: defaultPaddingLeft,
    backgroundImage: `url(${Images.withoutAccountsBackground})`,
    backgroundPosition: 'center bottom',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [Device.mobile]: {
      flexDirection: 'column',
      padding: 15
    }
  },
  avatar: {
    height: '80vh',
    width: 'auto',
    [Device.mobile]: {
      height: '60vh'
    }
  },
  label: {
    alignSelf: 'flex-start',
    fontSize: iconTitle,
    textAlign: 'left',
    [Device.mobile]: {
      paddingTop: 30
    }
  }
};
